import type { BidIntentStatus } from "../page-quotation/BidIntentControls/BidIntentControls";

export type Request = {
  id: string;
  project: string;
  org: string;
  /*category: ?*/
  date: string;
  timeLeft: Date;
  recipients: string[];
  intent: BidIntentStatus;
  hasBid: boolean;
  answered: boolean;
  version: string;
  deliveryStart: string;
  deliveryEnd: string;
  link: string;
  isDeleted: boolean;
  won: boolean;
}

export type FeaturedAdInfo = {
  errors?: {title?: string, image?: string}
  url?: string,
  image: {
    file: string,
  } | File,
  title: string,
  description?: string,
  startDate: Date,
  endDate: Date,
}

export const Period = {
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  DAY: 'DAY',
} as const;
export type Period = typeof Period[keyof typeof Period]

export type InvoiceInterval = {
  price: number,
  duration: number,
  period: Period,
  cancellationDelay: string,
}

export type AdApplicationStatus = 'PENDING' | 'REJECTED' | 'APPROVED';

export type SalesOrganizationApplicationStatus = 'PENDING' | 'SIGNED' | 'REJECTED' | 'AWAITING_MANUAL_APPROVAL';
